import { CommonBaseData } from "../shared/data/common-base-data";
import { N4074MainData } from "./n4074-main-data";

export class N4074OutputData extends CommonBaseData  {
  // 明細データ
  public detailData: N4074MainData[];
  // メッセージ本文
  public messejiHombun: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/n407/n4074-output-data.ts